.modal-backdrop{position:fixed;inset:0;background:rgba(15,23,42,.58);display:grid;place-items:center;padding:1rem;z-index:20}
.modal{width:min(34rem,100%);box-shadow:0 24px 80px rgba(15,23,42,.3)}
.modal label{display:grid;gap:.4rem;margin-top:1rem}
.modal input{width:100%;box-sizing:border-box;border:1px solid #cbd5e1;border-radius:.55rem;padding:.7rem;font:inherit}
.modal-actions{display:flex;justify-content:flex-end;gap:.6rem;margin-top:1.2rem}
.modal-actions button:disabled{opacity:.55;cursor:not-allowed}
